import { initializeApp } from 'firebase/app'
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from 'firebase/messaging'
import notificationEvents, {
  EVENT_REQUEST_PERMISSION,
} from './notificationevents'

export const register = async ({ onRegister, onNotification }, config) => {
  if ((await isSupported()) === false) {
    console.warn('Web notifications are not supported, skipping registration')

    return
  }

  const { vapidPublicKey: vapidKey, firebaseConfig, appIcon: icon } = config

  if (
    typeof vapidKey !== 'string' ||
    typeof firebaseConfig !== 'object' ||
    typeof icon !== 'string'
  ) {
    console.warn('Invalid web notification config, skipping registration')

    return
  }

  const app = initializeApp(firebaseConfig)
  const messaging = getMessaging(app)

  /** @type {ServiceWorkerRegistration} */
  let serviceWorkerRegistration

  onMessage(messaging, payload => {
    console.info('Received foreground notification')

    const { title, body, icon, ...data } = payload.data

    try {
      const notification = new Notification(title, { body, icon })

      notification.onclick = event => {
        event.preventDefault()

        const { appId, target, ...params } = data
        const route = { target, params }
        onNotification(route)

        notification.close()
      }
    } catch (err) {
      // Fallback to service worker notifications
      // Android does not support the Notification constructor method
      if (err instanceof TypeError) {
        if (serviceWorkerRegistration instanceof ServiceWorkerRegistration) {
          serviceWorkerRegistration.showNotification(title, {
            body,
            icon,
            data,
          })
        }
      }
    }
  })

  notificationEvents.addListener(EVENT_REQUEST_PERMISSION, async () => {
    try {
      const sw = navigator.serviceWorker
      serviceWorkerRegistration = await sw.register('/firebase-messaging-sw.js')

      // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerGlobalScope/notificationclick_event
      // TODO (michael-adalo): innfective, probably needs to go in service worker
      // serviceWorkerRegistration.addEventListener('notificationclick', event => {
      //   event.preventDefault()

      //   console.info('Notification clicked', event.notification)

      //   const { appId, target, ...params } = event.notification.data
      //   const route = { target, params }
      //   onNotification(route)

      //   event.notification.close()
      // })

      const token = await getToken(messaging, {
        vapidKey,
        serviceWorkerRegistration,
      })

      if (token) {
        onRegister(token)
      }
    } catch (e) {
      console.log('An error occurred while retrieving token. ', e)
    }
  })

  if (Notification.permission === 'granted') {
    notificationEvents.emit(EVENT_REQUEST_PERMISSION)
  }
}

export const requestPermission = () => {
  notificationEvents.emit(EVENT_REQUEST_PERMISSION)
}
